<template>
  <div>
    <div class="sr-comInfo">
      <div class="sr-layout-wrap">
        <el-image src="https://sara-infinity.com/logo.jpg" style="float: left; height: 10%;width: 10%"  />
        <div class="sr-comInfo-r" style="margin-top: 3%;margin-left: 3%">

          <div class="sr-comInfo-title J-title-comName">
            <div class="title-txt">
              <a href="https://www.sara-infinity.com">
                <h1 style="font-size: 22px">
                  {{title}}<i class="ob-icon icon-down"></i>
                </h1>
              </a>
            </div>

          </div>
          <div class="sr-comInfo-sign">
            <div class="sign-item">
              <i class="el-icon-message"></i> <span class="txt-year">525205929@qq.com</span>
            </div>
            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-phone"></i>
              <span class="txt-year">+86 18680557608</span>
            </div>

            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-location"></i>
              <span class="txt-year">ADDRESS: Room 803, No. 16 Tangjing Road,  Baiyun District, Guangzhou City</span>
            </div>
          </div>
        </div>
        <div style="float: right">

          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{language?"中文":"English"}}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <span @click="english()">
              <el-dropdown-item class="clearfix">
                   English
              </el-dropdown-item>
              </span>
              <span @click="china()">
              <el-dropdown-item class="clearfix"  >
                    中文
              </el-dropdown-item>
                   </span>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </div>
    </div>

    <el-menu
        default-active="1"
        class="el-menu-demo"
        mode="horizontal"
        @select=""
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="padding-left: 21.2%">
      <el-menu-item index="1">
        <router-link to="/home">{{language?"首页":"Home"}}</router-link>
      </el-menu-item>
      <el-menu-item index="2">
        <router-link to="/products">{{language?"产品":"Products"}}</router-link>
      </el-menu-item>
      <el-menu-item index="3">
        <router-link to="/aboutUs">{{language?"关于我们":"About Us"}}</router-link>
      </el-menu-item>
      <el-menu-item index="4" disabled>
        <router-link to="">{{language?"解决方案":"Solutions"}}</router-link>
      </el-menu-item>
      <el-menu-item index="5">
        <router-link to="/sendUs">{{language?"联系我们":"Send Us"}}</router-link>
      </el-menu-item>
    </el-menu>


    <div class="sr-layout-wrap sr-layout-resp" style="margin-top: 2%">
      <div class="sr-layout-main home-layout-main">
        <div class="J-spotlight-show">


          <div class="sr-layout-block">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">{{language?"热门产品":"Best Selling Models."}}</h2>
            </div>
            <div class="sr-layout-content">
              <div class="sr-layout-row">


                <div class="sr-layout-col-4 sr-proList" faw-module="Prod_list" faw-exposure product_id="pvImKCyLaEfT"
                     company_id="MbqJekDAbTiS" v-for="(item, index) in data" :key="index"
                     @click="sendMessageOpen(item.img)">
                  <div class="sr-proList-pic-wrap">
                    <div class="sr-proList-pic ">
                      <div class="prod-image ">
                        <a>
                          <img :src="addr+item.img" style="width: 100%; height: 100%"
                               :alt="item.title">
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="sr-proList-txt">
                    <div class="sr-proList-name">
                      <a :title="item.title">
                        {{ item.title }}
                      </a>
                    </div>
                    <div class="sr-proList-price" title="FOB Price: US $9-10 / Set">
                      <span class="sr-proList-unit">FOB Price: </span>
                      <span class="sr-proList-num"> {{ item.Price }} </span>
                      <span class="">/ Set</span>
                    </div>
                    <div class="sr-proList-price" title="Min. Order: 100 Sets">
                      <span class="sr-proList-unit">Min. Order: </span>
                      100 Sets
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>


          <div class="sr-layout-block">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">{{language?"中东热门产品":"Middle East Popular Models."}}</h2>
            </div>
            <div class="sr-layout-content">
              <div class="sr-layout-row">
                <div class="sr-layout-col-4 sr-proList" faw-module="Prod_list" faw-exposure product_id="pvImKCyLaEfT"
                     company_id="MbqJekDAbTiS" v-for="(item, index) in data2" :key="index"
                     @click="sendMessageOpen(item.img)">
                  <div class="sr-proList-pic-wrap">
                    <div class="sr-proList-pic ">
                      <div class="prod-image ">
                        <a>
                          <img :src="addr+item.img"
                               :alt="item.title">
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="sr-proList-txt">
                    <div class="sr-proList-name">
                      <a
                          :title="item.title">
                        {{ item.title }}
                      </a>
                    </div>
                    <div class="sr-proList-price" title="FOB Price: US $9-10 / Set">
                      <span class="sr-proList-unit">FOB Price: </span>
                      <span class="sr-proList-num"> {{ item.Price }} </span>
                      <span class="">/ Set</span>
                    </div>
                    <div class="sr-proList-price" title="Min. Order: 100 Sets">
                      <span class="sr-proList-unit">Min. Order: </span>
                      100 Sets
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>




<!--          <div class="sr-layout-block pad-block J-block" id="richNav_2" >

            <div class="sr-txt-title"  style="margin-bottom: 3%">
              <h2 class="sr-txt-h2">
                distributor</h2>
            </div>

            <el-image src="https://sara-infinity.com/logo1-1.jpg"   />
            <div class="sr-txt-title"  style="margin-top: 0.8%">
              <h3 class="sr-txt-h2">Qimah Al-Safinah For General Contracting and Trading LTD.</h3>
            </div>
            <div class="sr-comProfile-infos no-yes ">


              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label" style="margin-top: 0.8%;margin-bottom: 0.8%">
                  Phone: +964-782-462-0000
                </div>
                <div class="sr-comProfile-fields" style="margin-bottom: 0.8%">
                  Email: Qs@qs-groups.com
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label" style="margin-bottom: 0.8%">
                  Address: F107, Khillani Commercial Compound, Sinnak, Baghdad, Iraq.
                </div>
                <div class="sr-comProfile-fields" >
                  Website: www.qs-groups.com
                </div>

              </div>

            </div>

          </div>-->




          <div class="sr-layout-block J-msg-block" faw-module="supplier_inquiry" faw-exposure>
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">{{ language?"将您的消息发送到此供应商":"Send your message to this supplier" }}</h2>
            </div>
            <div class="sr-layout-content sr-sendMsg">
              <div class="sr-sendMsg-form obelisk-form">
                <input type="hidden" id="showRoomUrl"
                       value="">
                <input type="hidden" id="loginStatu" value="0"/>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>{{ language?"来自":"From:" }}
                  </div>
                  <div class="sr-sendMsg-field J-quick-inquiry-email-wrap">
                    <input class="input-text sr-sendMsg-input" name="senderMail" type="text"
                           :placeholder="language?'输入您的电子邮件地址':'Enter your email address'" value=""/>
                  </div>
                </div>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>{{language?"":"To:"}}
                  </div>
                  <div class="sr-sendMsg-field">

                    <span class="sr-sendMsg-name">{{language?"张女士":"sara. zhang"}}</span>
                  </div>
                </div>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>{{language?"信息:":"Message:" }}
                  </div>
                  <div class="sr-sendMsg-field">
                      <textarea class="input-textarea sr-sendMsg-area" name="content" id="inquiryContent" cols="90"
                                rows="5"
                                :placeholder="language?'我们建议您在此处详细说明您的产品要求和公司信息.':'EWe suggest you detail your product requirements and company information here.'"
                                maxlength="4000"></textarea>
                    <p class="sr-sendMsg-tips">{{language?"输入20到4000个字符.":"Enter between 20 to 4,000 characters."}}</p>
                  </div>
                </div>
                <div class="">
                  <div class="sr-sendMsg-label"></div>
                  <div class="sr-sendMsg-field">
                    <div id="captcha" style="float:left;"></div>
                    <input type="hidden" name="hmToken" class="J-hmToken" value=""/>
                    <input type="hidden" class="J-hmCaptchaId" value="18bd4c8e-230c-435c-9a1d-cb9309d80086"/>
                  </div>
                </div>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-field">
                    <input type="hidden" id="sourceReqType" name="sourceReqType" value="GLP"/>
                    <input type="hidden" name="showRoomQuickInquireFlag" value="1"/>
                    <input type="hidden" name="showRoomId" value="MbqJekDAbTiS"/>
                    <input type="hidden" name="compareFromPage" id="compareFromPage" value="1"/>
                    <button fun-inquiry-supplier class="btn btn-main sr-sendMsg-btn" id="inquirySend" @click="send()">
                      {{language?"发送":"Send" }}
                    </button>
                    <span class="sr-sendMsg-promote">{{language?"这不是你想要的吗？":"This is not what you are looking for?" }}</span>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="sr-layout-nav home-nav">
        <div class="sr-layout-block">
          <div class="sr-layout-subblock sr-side-proGroup" faw-module="Prod_group_filter" faw-exposure>
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">{{language?"产品列表":"Product Groups"}}</h2>
            </div>
            <ul class="sr-side-proGroup-list" style="margin-top: 1%">
              <li v-for="(item, index) in list" :key="index">
                <a ref="nofollow"
                   otor
                   :title="item" ads-data="">{{ item }}</a>
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>





    <div class="m-footer pad-footer m-sr-footer">
      <div class="grid">
        <div class="m-footer-simple-links pad-footer-simple">
          <div class="m-footer-simple-links-group pad-footer-hide">
            <div class="m-footer-simple-links-row">
              <a>{{language?"热门产品":"Hot Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国产品":"China Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国制造商/供应商":"Chinese Manufacturers/Suppliers"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国批发":"China Wholesale"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"批发价格":"Wholesale Price"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"行业网站":"Industry Sites"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"区域渠道":"Regional Channels"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"产品指数":"Product Index"}}</a>

            </div>

          </div>
          <div class="m-footer-simple-links-group pad-footer-oneline">
            <div class="m-footer-simple-links-row m-footer-copyright">
              Copyright &copy; 2023-2024 <a class="J-focusChinaLink" href="https://www.sara-infinity.com/"
                                            rel="nofollow"
                                            target="_blank">{{language?"广州至臻机车配件有限公司":"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."}}</a>&nbsp;{{language?"保留所有权利":"All Rights Reserved."}}

            </div>
            <span class="m-gap-line"></span>
            <div class="m-footer-simple-links-row">
              <a rel="nofollow" target="_self">{{language?"保留所有权利":"User Agreement"}}</a>
            </div>
          </div>
          <div style="display: flex;justify-content: center;width: 100%">

            <div class="m-footer-simple-links-row m-footer-govIcon pad-hide" style="color: blue" >
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483772" rel="noreferrer" target="_blank"><i class="m-ico m-ico-police-new"></i>粤公网安备44011102483772</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" data-v-644aa589="" style="margin-left: 20px;">粤ICP备2024199978号</a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-dialog center
               :visible.sync="sendMessageDialog"
               :close-on-click-modal="false"
               @close="closeDialog"
               width="50%">


      <div class="sr-layout-block J-msg-block" faw-module="supplier_inquiry" faw-exposure>
        <div class="sr-txt-title">
          <h2 class="sr-txt-h2">{{ language?"将您的消息发送到此供应商":"Send your message to this supplier" }}</h2>
        </div>
        <div class="sr-layout-content sr-sendMsg">
          <div class="sr-sendMsg-form obelisk-form">

            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>{{ language?"来自":"From:" }}
              </div>
              <div class="sr-sendMsg-field J-quick-inquiry-email-wrap">
                <input class="input-text sr-sendMsg-input" name="senderMail" type="text"
                       :placeholder="language?'输入您的电子邮件地址':'Enter your email address'" value=""/>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>{{language?"":"To:"}}
              </div>
              <div class="sr-sendMsg-field">

                <span class="sr-sendMsg-name">{{language?"张女士":"sara. zhang"}}</span>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-label">
                <em>*</em>{{language?"信息:":"Message:" }}
              </div>
              <div class="sr-sendMsg-field">
                      <textarea class="input-textarea sr-sendMsg-area" name="content" id="inquiryContent" cols="90"
                                rows="5"
                                :placeholder="language?'我们建议您在此处详细说明您的产品要求和公司信息.':'EWe suggest you detail your product requirements and company information here.'"
                                maxlength="4000"></textarea>
                <p class="sr-sendMsg-tips">{{language?"输入20到4000个字符.":"Enter between 20 to 4,000 characters."}}</p>
              </div>
            </div>
            <div class="">
              <div class="sr-sendMsg-label"></div>
              <div class="sr-sendMsg-field">
                <div id="captcha" style="float:left;"></div>
                <input type="hidden" name="hmToken" class="J-hmToken" value=""/>
                <input type="hidden" class="J-hmCaptchaId" value="18bd4c8e-230c-435c-9a1d-cb9309d80086"/>
              </div>
            </div>
            <div class="sr-sendMsg-row">
              <div class="sr-sendMsg-field">

                <button fun-inquiry-supplier class="btn btn-main sr-sendMsg-btn" id="inquirySend" @click="send()">
                  {{language?"发送":"Send" }}
                </button>
                <span class="sr-sendMsg-promote">{{language?"这不是你想要的吗？":"This is not what you are looking for?" }}</span>

              </div>
            </div>

          </div>
        </div>
      </div>


    </el-dialog>


  </div>
</template>

<script>
export default {
  data() {
    return {
      localImage: require('@/assets/img/logo.jpg'),
      language:false,
      title:"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.",
      sendMessageDialog: false,
      addr: "https://sara-infinity.com/",
      list: ["Motorcycle Cylinder Kits For HONDA",
        "Motorcycle Cylinder Kits For YAMAHA",
        "Motorcycle Cylinder Kits For SUZUKI",
        "Motorcycle Cylinder Kits For BAJAJ",
        "Motorcycle Cylinder Kits For PIAGGIO",
        "Motorcycle Cylinder Kit For HERO",
        "Motorcycle Cylinder Kits For TVS",
        "Motorcycle Bigbore Racing Cylinder Kits",
        "Motorcycle Engine",
        "Motorcycle Piston Ring Kit",
        "Motorcycle Gasket",
        "Motorcycle Spark Plug",
        "Motorcycle Carburetor",
        "Chainsae &amp; Grasscutter Cylinder Kits",
        "Outboard Engine Cylinder Liner Sleeve",
        "Other Motorcycle Cylinder Kits"],
      data: [
        {
          title: "E-bike Model SY-009-Ⅲ, Performance Max Speed: 50-55km/h Loading 120kg,Colors Black/Green/Yellow/others,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E1.png",
          Price: "US $830-860",

        }, {
          title: "E-bike Model SY-A8, Performance Max Speed: 50-55km/h Loading 150kg,Colors Bule/Green/Yellow/others,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E2.png",
          Price: "US $850-880 ",

        }, {
          title: "E-bike Model SY-A8L, Performance Max Speed: 60-80km/h Loading 150kg,Colors Black/Green/Yellow/others,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E3.png",
          Price: "US $955-973",

        }, {
          title: "E-bike Model SY-Sue, Performance Max Speed: 70km/h Loading 150kg,Colors Black/Green/Yellow/others,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E4.png",
          Price: "US $915-918",

        }, {
          title: "E-bike Model SY-T90, Performance Max Speed: 50-55km/h Loading 150kg,Colors Customiztion,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E5.png",
          Price: "US $845-848",

        }, {
          title: "E-bike Model SY-T90-T, Performance Max Speed: 70km/h Loading 150kg,Colors Customiztion,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E6.png",
          Price: "US $939-960 ",

        }, {
          title: "E-bike Model SY-JH, Performance Max Speed: 40km/h Loading 150kg,Colors Customiztion,Motor Type: Brushless Power: 500 watts",
          alt: "",
          href: "",
          img: "E7.png",
          Price: "US $760-780",

        }, {
          title: "E-bike Model SY-H26-2, Performance Max Speed: 70km/h Loading 150kg,Colors Customiztion,Motor Type: Brushless Power: 1200 watts",
          alt: "",
          href: "",
          img: "E8.png",
          Price: "US $860-872",

        }
     /*   {
          title: "Trkimal 52.4mm Engine Parts Cylinder big bore kits with Gaskets and Piston Set for 4 Stroke Chinese TaoTao Coolster ATV 110cc Pit Quad Dirt Bike Go Kart",
          alt: "",
          href: "",
          img: "1.png",
          Price: "US $30-60",

        }, {
          title: "Cylinder Piston Gasket Kit 250cc CG250 Chinese ATV Dirt Bike Engine Cylinder Kit Cylinder Piston Gasket Fits Cg250 250cc Air Cooled Vertical Engine Air Cooled Engine ATV Quad Bike Go Kart Cylinder Kit",
          alt: "",
          href: "",
          img: "2.png",
          Price: "US $50-80 ",

        }, {
          title: "DENEST Cylinder Gasket Piston Rings Set Top End Rebuild Kit Compatible for 2000-2006 Honda Rancher 350 TRX350 4x4",
          alt: "",
          href: "",
          img: "3.png",
          Price: "US $55-73",

        }, {
          title: "Engine Piston Kit, Metal Piston Rings Gasket Set For 110cc 125cc ATV Dirt Pit Bike Go Kart",
          alt: "",
          href: "",
          img: "4.png",
          Price: "US $15-18",

        }, {
          title: "Lumix GC Gasket Piston Clip Cylinder For KAZUMA Meerkat Redcat 50 ATV QUAD 50CC",
          alt: "",
          href: "",
          img: "5.png",
          Price: "US $45-48",

        }, {
          title: "54mm Big Bore Kit for Honda Dirt Bike ATV - Convert 110cc to 125cc Cylinder Piston Ring Gasket Set",
          alt: "",
          href: "",
          img: "6.png",
          Price: "US $39-60 ",

        }, {
          title: "250cc Cylinder Piston Gasket Kit 67mm CG250 167FMM Chinese ATV Dirt Bike TaoTao",
          alt: "",
          href: "",
          img: "7.png",
          Price: "US $60-80",

        }, {
          title: "ZhdnBhnos 67mm Big Bore Cylinder Piston Gasket Kit for CG250 250cc Air Cooled Vertical Engine ATV Quad Go Kart Dirt Pit Bike",
          alt: "",
          href: "",
          img: "8.png",
          Price: "US $60-72",

        }*/, {
          title: "Trkimal GY6 150cc 57.4mm Bore Cylinder kit with Piston Kit 4 Stroke 152QMI 157QMJ for TAOTAO JONWAY ZNEN Roketa ATV Moped Go-Kart",
          alt: "",
          href: "",
          img: "9.png",
          Price: "S $30-40",

        }, {
          title: "Cylinder Gasket Piston Top End Replacement for 1992-2000 Yamaha Timberwolf 250 YFB250 4BD-11310-01-00",
          alt: "",
          href: "",
          img: "10.png",
          Price: "US $80",

        }, {
          title: "SEBLAFF Cylinder Piston Top End Rebuild Kit For Honda Recon 250 TRX250 TRX250EX",
          alt: "",
          href: "",
          img: "11.png",
          Price: "US $95",

        },
        {
          title: "Farmertec 52mm Cylinder Piston Kit WT Pin Ring Circlip Compatible with Stihl MS461 R/RZ/Z/Magnum Chainsaw 1128 020 1250",
          alt: "",
          href: "",
          img: "0.png",
          Price: "US $40-70",

        },
      ],

      data2: [
        {
          title: "SIZE TYPE P.R. 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-17 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-17 T/T 4/6/8 3.00-18 T/T 4/6/8",
          alt: "SY-M001",
          href: "",
          img: "12.png",
          Price: "US $15-18",

        }, {
          title: "SIZE TYPE P.R. 2.75-14 T/T 4/6/8 2.50-17 T/T 4/6/8 2.75-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-18 T/T&T/L 4/6/8",
          alt: "SY-M002",
          href: "",
          img: "13.png",
          Price: "US $12-15",

        }, {
          title: "SIZE TYPE P.R. 2.25-17 T/T 4/6/8 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8",
          alt: "SY-M003",
          href: "",
          img: "14.png",
          Price: "US $9-10 ",

        }, {
          title: "SIZE TYPE P.R. 3.25-16 T/T 4/6/8 3.25-18 T/T&T/L 4/6/8 110/90-16 T/T&T/L 59P/65P",
          alt: "SY-M004",
          href: "",
          img: "15.png",
          Price: "US $12-13",

        }, {
          title: "90/90-18 T/T&T/L 51P/57P",
          alt: "SY-M005",
          href: "",
          img: "16.png",
          Price: "US $15-18",

        }, {
          title: "2.25-17 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8 3.00-18 T/T 4/6/8",
          alt: "SY-M006",
          href: "",
          img: "17.png",
          Price: "US $6-10",

        }, {
          title: "3.00-18 T/T 4/6/8 2.75-14 T/T 4/6/8",
          alt: "SY-M008",
          href: "",
          img: "18.png",
          Price: "US $30-35 ",

        }, {
          title: "SY-MOO9 规格：3.00-18 T/T&T/L 4/6/8PR",
          alt: "SY-M009",
          href: "",
          img: "19.png",
          Price: "US $9-11",

        }, {
          title: "SY-M011 规格型号：3.00-18 T/T 4/6/8PR",
          alt: "SY-M0011",
          href: "",
          img: "20.png",
          Price: "US $38-40",

        }, {
          title: "SY-M018 SIZE 3.25-16 P.R. 4/6/8PR C TT",
          alt: "SY-M0018",
          href: "",
          img: "21.png",
          Price: "S $20",

        }, {
          title: "SY-M019 60/90-17 T/T&T/L 30P/36P 70/90-17 T/T&T/L 38P/43P 80/90-17 T/L 44P/50P 90/80-17 46P/52P 110/70-17 T/L 54P 140/70-17 T/L 66P/72P",
          alt: "SY-M0019",
          href: "",
          img: "22.png",
          Price: "US $11-12",

        }, {
          title: "SY-M022 规格型号： 3.00-17 T/T 4/6/8PR 3.00-18 T/T 4/6/8PR",
          alt: "SY-M0022",
          href: "",
          img: "23.png",
          Price: "US $22-25",

        },
      ]
    }
  },
  methods: {

    sendMessageOpen(data) {
      let that = this
      that.sendMessageDialog = true
    },
    closeDialog() {
      let that = this
      that.sendMessageDialog = false

    },

    send() {
      this.$message.success("Successfully");
      this.closeDialog()

    },

    isIE() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.info('ie浏览器不兼容！')
        return true;
      }
      return false;
    },


    china(){
      this.language =true
      this.title ="广州至臻机车配件有限公司"
      this.list = ["本田摩托车气缸套件",
        "雅马哈摩托车气缸套件",
        "铃木摩托车气缸套件",
        "百加吉摩托车气缸套件",
        "比亚乔摩托车气缸套件",
        "本田摩托车气缸套件",
        "TVS摩托车气缸套件",
        "摩托车大口径赛车气缸套件",
        "摩托车发动机",
        "摩托车活塞环套件",
        "摩托车垫片",
        "摩托车火花塞",
        "摩托车化油器",
        "气缸套件",
        "发动机外侧气缸套",
        "其他摩托车气缸套件其他摩托车气缸套件"]

      this.data= [
        {
          title: "Trkimal 52.4mm发动机零件气缸大孔套件，带垫圈和活塞套件，适用于4冲程中国陶陶冷却器ATV 110cc坑四轮越野自行车卡丁车",
          alt: "",
          href: "",
          img: "1.png",
          Price: "US $30-60",

        }, {
          title: "气缸活塞垫圈套件250cc CG250中国ATV越野自行车发动机气缸套件气缸活塞垫圈适合CG250 250cc风冷立式发动机风冷发动机ATV四轮自行车卡丁车气缸套件",
          alt: "",
          href: "",
          img: "2.png",
          Price: "US $50-80 ",

        }, {
          title: "DENEST气缸垫圈活塞环套件顶端重建套件适用于2000-2006本田Rancher 350 TRX350 4x4",
          alt: "",
          href: "",
          img: "3.png",
          Price: "US $55-73",

        }, {
          title: "发动机活塞套件，金属活塞环垫圈套件，适用于110cc 125cc ATV地坑自行车卡丁车",
          alt: "",
          href: "",
          img: "4.png",
          Price: "US $15-18",

        }, {
          title: "Lumix GC垫圈活塞夹缸用于KAZUMA猫鼬Redcat 50 ATV QUAD 50CC",
          alt: "",
          href: "",
          img: "5.png",
          Price: "US $45-48",

        }, {
          title: "适用于本田越野自行车ATV的54mm大口径套件-将110cc气缸活塞环垫圈套件转换为125cc",
          alt: "",
          href: "",
          img: "6.png",
          Price: "US $39-60 ",

        }, {
          title: "250cc气缸活塞垫片套件67mm CG250 167FMM中国ATV越野自行车 TaoTao",
          alt: "",
          href: "",
          img: "7.png",
          Price: "US $60-80",

        }, {
          title: "ZhdnBhnos 67mm大口径气缸活塞垫片套件，适用于CG250 250cc风冷立式发动机ATV四轮卡丁车地坑自行车",
          alt: "",
          href: "",
          img: "8.png",
          Price: "US $60-72",

        }, {
          title: "Trkimal GY6 150cc 57.4mm缸径气缸套件，带活塞套件4冲程152QMI 157QMJ，适用于TAOTAO JONWAY ZNEN Roketa ATV Moped Go Kart",
          alt: "",
          href: "",
          img: "9.png",
          Price: "S $30-40",

        }, {
          title: "1992-2000雅马哈Timberwolf 250 YFB250 4BD-11310-01-00气缸垫活塞顶端的更换",
          alt: "",
          href: "",
          img: "10.png",
          Price: "US $80",

        }, {
          title: "SEBLAFF气缸活塞顶端重建套件，适用于Honda Recon 250 TRX250 TRX250EX",
          alt: "",
          href: "",
          img: "11.png",
          Price: "US $95",

        },
        {
          title: "Farmertec 52mm气缸活塞套件WT销环卡簧与Stihl MS461 R/RZ/Z/万能电锯1128 020 1250兼容",
          alt: "",
          href: "",
          img: "0.png",
          Price: "US $40-70",

        },
      ]

     this.data2= [
        {
          title: "尺寸类型 P.R.2.50-17吨/吨4/6/8 2.50-18吨/吨4/6/8 2.75-17吨/吨4/5/8 2.75-18吨/吨/4/6/8 3.00-17吨/T 4/6/8 3.00-18吨/T 4/6/8",
          alt: "SY-M001",
          href: "",
          img: "12.png",
          Price: "US $15-18",

        }, {
          title: "尺寸类型 P.R.2.75-14 T/T 4/6/8 2.50-17 T/T 4/6%8 2.75-17 T/T 4/6/82.50-18 T/T 4/6-8 2.75-18 T/T 4/6:8 3.00-18 T/T&T/L 4/6/8",
          alt: "SY-M002",
          href: "",
          img: "13.png",
          Price: "US $12-15",

        }, {
          title: "尺寸类型 P.R.2.25-17 T/T 4/6/8 2.50-17 T/T 4/6%8 2.50-18 T/T 4/6/82.75-18 T/T&T/L 4/6/8",
          alt: "SY-M003",
          href: "",
          img: "14.png",
          Price: "US $9-10 ",

        }, {
          title: "尺寸类型 P.R. 3.25-16 T/T 4/6/8 3.25-18 T/T&T/L 4/6/8 110/90-16 T/T&T/L 59P/65P",
          alt: "SY-M004",
          href: "",
          img: "15.png",
          Price: "US $12-13",

        }, {
          title: "90/90-18 T/T&T/L 51P/57P",
          alt: "SY-M005",
          href: "",
          img: "16.png",
          Price: "US $15-18",

        }, {
          title: "2.25-17 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8 3.00-18 T/T 4/6/8",
          alt: "SY-M006",
          href: "",
          img: "17.png",
          Price: "US $6-10",

        }, {
          title: "3.00-18 T/T 4/6/8 2.75-14 T/T 4/6/8",
          alt: "SY-M008",
          href: "",
          img: "18.png",
          Price: "US $30-35 ",

        }, {
          title: "SY-MOO9 规格：3.00-18 T/T&T/L 4/6/8PR",
          alt: "SY-M009",
          href: "",
          img: "19.png",
          Price: "US $9-11",

        }, {
          title: "SY-M011 规格型号：3.00-18 T/T 4/6/8PR",
          alt: "SY-M0011",
          href: "",
          img: "20.png",
          Price: "US $38-40",

        }, {
          title: "SY-M018 规格型号 3.25-16 P.R. 4/6/8PR C TT",
          alt: "SY-M0018",
          href: "",
          img: "21.png",
          Price: "S $20",

        }, {
          title: "SY-M019 60/90-17 T/T&T/L 30P/36P 70/90-17 T/T&T/L 38P/43P 80/90-17 T/L 44P/50P 90/80-17 46P/52P 110/70-17 T/L 54P 140/70-17 T/L 66P/72P",
          alt: "SY-M0019",
          href: "",
          img: "22.png",
          Price: "US $11-12",

        }, {
          title: "SY-M022 规格型号： 3.00-17 T/T 4/6/8PR 3.00-18 T/T 4/6/8PR",
          alt: "SY-M0022",
          href: "",
          img: "23.png",
          Price: "US $22-25",

        },
      ]

    },
    english(){
      this.language =false
      this.title ="GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."
      this.list = ["Motorcycle Cylinder Kits For HONDA",
        "Motorcycle Cylinder Kits For YAMAHA",
        "Motorcycle Cylinder Kits For SUZUKI",
        "Motorcycle Cylinder Kits For BAJAJ",
        "Motorcycle Cylinder Kits For PIAGGIO",
        "Motorcycle Cylinder Kit For HERO",
        "Motorcycle Cylinder Kits For TVS",
        "Motorcycle Bigbore Racing Cylinder Kits",
        "Motorcycle Engine",
        "Motorcycle Piston Ring Kit",
        "Motorcycle Gasket",
        "Motorcycle Spark Plug",
        "Motorcycle Carburetor",
        "Chainsae &amp; Grasscutter Cylinder Kits",
        "Outboard Engine Cylinder Liner Sleeve",
        "Other Motorcycle Cylinder Kits"]

      this.data= [
        {
          title: "Trkimal 52.4mm Engine Parts Cylinder big bore kits with Gaskets and Piston Set for 4 Stroke Chinese TaoTao Coolster ATV 110cc Pit Quad Dirt Bike Go Kart",
          alt: "",
          href: "",
          img: "1.png",
          Price: "US $30-60",

        }, {
          title: "Cylinder Piston Gasket Kit 250cc CG250 Chinese ATV Dirt Bike Engine Cylinder Kit Cylinder Piston Gasket Fits Cg250 250cc Air Cooled Vertical Engine Air Cooled Engine ATV Quad Bike Go Kart Cylinder Kit",
          alt: "",
          href: "",
          img: "2.png",
          Price: "US $50-80 ",

        }, {
          title: "DENEST Cylinder Gasket Piston Rings Set Top End Rebuild Kit Compatible for 2000-2006 Honda Rancher 350 TRX350 4x4",
          alt: "",
          href: "",
          img: "3.png",
          Price: "US $55-73",

        }, {
          title: "Engine Piston Kit, Metal Piston Rings Gasket Set For 110cc 125cc ATV Dirt Pit Bike Go Kart",
          alt: "",
          href: "",
          img: "4.png",
          Price: "US $15-18",

        }, {
          title: "Lumix GC Gasket Piston Clip Cylinder For KAZUMA Meerkat Redcat 50 ATV QUAD 50CC",
          alt: "",
          href: "",
          img: "5.png",
          Price: "US $45-48",

        }, {
          title: "54mm Big Bore Kit for Honda Dirt Bike ATV - Convert 110cc to 125cc Cylinder Piston Ring Gasket Set",
          alt: "",
          href: "",
          img: "6.png",
          Price: "US $39-60 ",

        }, {
          title: "250cc Cylinder Piston Gasket Kit 67mm CG250 167FMM Chinese ATV Dirt Bike TaoTao",
          alt: "",
          href: "",
          img: "7.png",
          Price: "US $60-80",

        }, {
          title: "ZhdnBhnos 67mm Big Bore Cylinder Piston Gasket Kit for CG250 250cc Air Cooled Vertical Engine ATV Quad Go Kart Dirt Pit Bike",
          alt: "",
          href: "",
          img: "8.png",
          Price: "US $60-72",

        }, {
          title: "Trkimal GY6 150cc 57.4mm Bore Cylinder kit with Piston Kit 4 Stroke 152QMI 157QMJ for TAOTAO JONWAY ZNEN Roketa ATV Moped Go-Kart",
          alt: "",
          href: "",
          img: "9.png",
          Price: "S $30-40",

        }, {
          title: "Cylinder Gasket Piston Top End Replacement for 1992-2000 Yamaha Timberwolf 250 YFB250 4BD-11310-01-00",
          alt: "",
          href: "",
          img: "10.png",
          Price: "US $80",

        }, {
          title: "SEBLAFF Cylinder Piston Top End Rebuild Kit For Honda Recon 250 TRX250 TRX250EX",
          alt: "",
          href: "",
          img: "11.png",
          Price: "US $95",

        },
        {
          title: "Farmertec 52mm Cylinder Piston Kit WT Pin Ring Circlip Compatible with Stihl MS461 R/RZ/Z/Magnum Chainsaw 1128 020 1250",
          alt: "",
          href: "",
          img: "0.png",
          Price: "US $40-70",

        },
      ]

      this.data2= [
        {
          title: "SIZE TYPE P.R. 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-17 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-17 T/T 4/6/8 3.00-18 T/T 4/6/8",
          alt: "SY-M001",
          href: "",
          img: "12.png",
          Price: "US $15-18",

        }, {
          title: "SIZE TYPE P.R. 2.75-14 T/T 4/6/8 2.50-17 T/T 4/6/8 2.75-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T 4/6/8 3.00-18 T/T&T/L 4/6/8",
          alt: "SY-M002",
          href: "",
          img: "13.png",
          Price: "US $12-15",

        }, {
          title: "SIZE TYPE P.R. 2.25-17 T/T 4/6/8 2.50-17 T/T 4/6/8 2.50-18 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8",
          alt: "SY-M003",
          href: "",
          img: "14.png",
          Price: "US $9-10 ",

        }, {
          title: "SIZE TYPE P.R. 3.25-16 T/T 4/6/8 3.25-18 T/T&T/L 4/6/8 110/90-16 T/T&T/L 59P/65P",
          alt: "SY-M004",
          href: "",
          img: "15.png",
          Price: "US $12-13",

        }, {
          title: "90/90-18 T/T&T/L 51P/57P",
          alt: "SY-M005",
          href: "",
          img: "16.png",
          Price: "US $15-18",

        }, {
          title: "2.25-17 T/T 4/6/8 2.75-18 T/T&T/L 4/6/8 3.00-18 T/T 4/6/8",
          alt: "SY-M006",
          href: "",
          img: "17.png",
          Price: "US $6-10",

        }, {
          title: "3.00-18 T/T 4/6/8 2.75-14 T/T 4/6/8",
          alt: "SY-M008",
          href: "",
          img: "18.png",
          Price: "US $30-35 ",

        }, {
          title: "SY-MOO9 规格：3.00-18 T/T&T/L 4/6/8PR",
          alt: "SY-M009",
          href: "",
          img: "19.png",
          Price: "US $9-11",

        }, {
          title: "SY-M011 规格型号：3.00-18 T/T 4/6/8PR",
          alt: "SY-M0011",
          href: "",
          img: "20.png",
          Price: "US $38-40",

        }, {
          title: "SY-M018 SIZE 3.25-16 P.R. 4/6/8PR C TT",
          alt: "SY-M0018",
          href: "",
          img: "21.png",
          Price: "S $20",

        }, {
          title: "SY-M019 60/90-17 T/T&T/L 30P/36P 70/90-17 T/T&T/L 38P/43P 80/90-17 T/L 44P/50P 90/80-17 46P/52P 110/70-17 T/L 54P 140/70-17 T/L 66P/72P",
          alt: "SY-M0019",
          href: "",
          img: "22.png",
          Price: "US $11-12",

        }, {
          title: "SY-M022 规格型号： 3.00-17 T/T 4/6/8PR 3.00-18 T/T 4/6/8PR",
          alt: "SY-M0022",
          href: "",
          img: "23.png",
          Price: "US $22-25",

        },
      ]

    }

  },

  mounted() {
    let random = Math.floor(Math.random() * 5) + 1;
    this.bgImage = {
      backgroundImage: 'url(' + require('../assets/img/bg.jpg'),
      backgroundRepeat: 'no-repeat',

    };
    if (this.isIE()) {
      this.$confirm('此平台不兼容ie浏览器，使用ie浏览器可能会出现未知错误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      });
    }

    this.formWidth = 'width: 500px;'

  }
}
</script>

<style scoped>


</style>
